import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=2ecfaa30&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=2ecfaa30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecfaa30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecfaa30')) {
      api.createRecord('2ecfaa30', component.options)
    } else {
      api.reload('2ecfaa30', component.options)
    }
    module.hot.accept("./BasicInfo.vue?vue&type=template&id=2ecfaa30&scoped=true&", function () {
      api.rerender('2ecfaa30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/report-analysis-detail/components/BasicInfo.vue"
export default component.exports